import config from '../Config'
import { create } from 'apisauce'

export const restApi = create({
  baseURL: config.baseUrl
})

const api = {
  setToken: token => {
    restApi.setHeader('X-Auth-Token', `${token}`)
  },
  login: credentials => {
    return restApi.post('usuarios/login', credentials)
  },
  logout: () => restApi.post('usuarios/logout'),
  ping: () => restApi.post('usuarios/ping'),
  getUserInfo: () => restApi.get('usuarios/me'),
  uploadImage: async (solicitacaoId, file) => {
    let formData = new FormData()
    formData.append('image', file)
    formData.append('solicitacaoId', solicitacaoId)
    return restApi.post('images/upload', formData, {
      header: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  uploadFile: (solicitacaoId, file) => {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('solicitacaoId', solicitacaoId)
    return restApi.post('files/upload', formData, {
      header: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getConfigValue: chave => restApi.get(`configuracoes/${chave}`),
  solicitacaoCargaKmm: placa => restApi.get(`solicitacao-carga-kmm/${placa}`)
}

api.upload = async (solicitacaoId, file, atributo) => {
  if (file.type.split('/')[0] === 'image') {
    return api.uploadImage(solicitacaoId, file, atributo)
  }
  return api.uploadFile(solicitacaoId, file, atributo)
}

export default api
